import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLoading = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	style: {
		margin: "auto",
		background: "none",
		display: "block",
		shapeRendering: "auto"
	},
	width: "60px",
	height: "60px",
	viewBox: "0 0 100 100",
	preserveAspectRatio: "xMidYMid",
	...props,
	children: /* @__PURE__ */ _jsx("circle", {
		cx: 50,
		cy: 50,
		fill: "none",
		strokeWidth: 6,
		r: 35,
		strokeDasharray: "164.93361431346415 56.97787143782138",
		children: /* @__PURE__ */ _jsx("animateTransform", {
			attributeName: "transform",
			type: "rotate",
			repeatCount: "indefinite",
			dur: "1s",
			values: "0 50 50;360 50 50",
			keyTimes: "0;1"
		})
	})
});
export { SvgLoading as ReactComponent };
